import { orchestrator } from 'satcheljs';
import toggleIgnoreConversations from '../actions/toggleIgnoreConversations';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { IgnoreConversationsConfirmDialog } from 'owa-mail-ignore-view';
import { listViewStore, MailRowDataPropertyGetter } from 'owa-mail-list-store';
import ignoreConversationsService from '../services/ignoreConversationsService';
import { raiseAction } from 'satcheljs/lib/legacy/stitch';
import { actionNames } from 'owa-mail-store-actions';
import strings from 'owa-strings/owa-mail-strings';
import { format } from 'owa-strings';
import updateUserConfigurationPont from '../actions/actionCreators/updateUserConfigurationPont';
import { logUsage } from 'owa-analytics';
export default orchestrator(toggleIgnoreConversations, function (actionMessage) {
    var shouldIgnore = actionMessage.shouldIgnore;
    var rowKeysToIgnore = actionMessage.rowKeysToIgnore;
    var pontType = shouldIgnore
        ? 128 /* IgnoreConversation */
        : 256 /* CancelIgnoreConversation */;
    logUsage('TnS_Ignore', [actionMessage.actionSource, shouldIgnore]);
    // show dialog if pont is set
    if ((pontType & getUserConfiguration().UserOptions.NewEnabledPonts) == pontType) {
        var dialogTitle = void 0;
        if (shouldIgnore) {
            dialogTitle =
                rowKeysToIgnore.length == 1
                    ? strings.ignore_ignoreDialogTitle
                    : format(strings.ignore_ignoreDialogTitleNItems, rowKeysToIgnore.length);
        }
        else {
            dialogTitle =
                rowKeysToIgnore.length == 1
                    ? strings.ignore_stopIgnoringDialogTitle
                    : format(strings.ignore_stopIgnoringDialogTitleNItems, rowKeysToIgnore.length);
        }
        var dialogText = shouldIgnore
            ? strings.ignore_ignoreDialogSubtext
            : strings.ignore_stopIgnoringDialogSubtext;
        var dialog = new IgnoreConversationsConfirmDialog(dialogTitle, dialogText, function (checked) {
            if (checked) {
                updateUserConfigurationPont(pontType);
            }
            internalToggleIgnoreConversations(actionMessage.tableViewId, actionMessage.rowKeysToIgnore, shouldIgnore);
        }, function () { } /* onDismiss */);
        dialog.show();
    }
    else {
        // pont already set, toggle ignore without dialog
        internalToggleIgnoreConversations(actionMessage.tableViewId, actionMessage.rowKeysToIgnore, shouldIgnore);
    }
});
function internalToggleIgnoreConversations(tableViewId, rowKeysToIgnore, shouldIgnore) {
    var conversationIds = [];
    var tableView = listViewStore.tableViews.get(tableViewId);
    for (var _i = 0, rowKeysToIgnore_1 = rowKeysToIgnore; _i < rowKeysToIgnore_1.length; _i++) {
        var rowKey = rowKeysToIgnore_1[_i];
        conversationIds.push(MailRowDataPropertyGetter.getConversationId(rowKey, tableView));
    }
    ignoreConversationsService(conversationIds, tableView.tableQuery.folderId, shouldIgnore);
    // clean up items client side
    raiseAction(actionNames.DeleteConversationStoreUpdate)(conversationIds, tableView);
}
//# sourceMappingURL=toggleIgnoreConversationsOrchestrator.js.map